import React, { Component } from "react";
import   "./EditorError.scss";
class EditorError extends Component {

  render() {
    return (
    <div className = "editorError">
          <div>
              <div className="editorError-title">{this.props.title} </div>
          {this.props.isDefaultLiveSite?
           <div style={{marginTop:"200px"}}>
              <div className="editorError-defaultLiveSite-info">
                 <div> {this.props.titleInfo}    </div> 
                 <div> {this.props.subTitleInfo} </div>
              </div>
           </div>
            :
            <div className="editorError-info">
               
                    <div> {this.props.titleInfo}    </div> 
                    <div> {this.props.subTitleInfo} </div>
                
            </div>
            }
          </div> 
    </div>
    );
  }
}

export default EditorError;


// WEBPACK FOOTER //
// ./src/widget/components/editorError/EditorError.js